<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>

        <Dialog modal
                :visible="true"
                :closable="false"
                :style="{ width: 'auto' }">
            <template #header>
                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-size: 16px; font-weight: bold;">
                    <div>{{ __('Collective sheets update') }}</div>
                    <div v-html="period"></div>
                </div>
            </template>

            <v-form name="collectiveSheetForm"
                    class=""
                    style="padding:10px;">
                <div v-if="collectiveData.length == 0"
                     class="grid sheet-total-result justify-content-center"
                     style="margin-bottom:20px">
                    {{ __('No workers to assess') }}
                </div>
                <div v-else
                     class="warning-for-users">
                    {{ __('Remember to set up HR event L4 for workers who were on sick leave throughout the bonus period') }}
                </div>
                <div v-for="(premiumGroupWorkers, premium_group_symbol) in workerSheetsData"
                     :key="premium_group_symbol">

                    <div class="grid sheet-section-title justify-content-center"
                         style="padding-bottom:15px;">
                        {{ __('Premium group') }}: {{ premium_group_symbol }}
                    </div>

                    <div v-for="(row, worker_data) in premiumGroupWorkers"
                         :key="worker_data"
                         class="grid">
                        <div class="col-12 worker-name sheet-box-divider"
                             style="margin-bottom:0;margin-left:8px;padding-left:5px; background-color:#eee"
                             v-html="worker_data"></div>
                        <div class="col-12">
                            <FormRepeaterTable v-if="!workerHrEvents[row[0]['worker_id']] || hrEventsValues[workerHrEvents[row[0]['worker_id']]]?.percentValue > 0"
                                               v-model:record="collectiveData[premium_group_symbol][worker_data]"
                                               :keys="{ 'criterion_name': null, 'weight': 0, 'assessment': 0, 'result': null, 'justification': null }"
                                               :disabled="false"
                                               :isFirstRowEmpty="false"
                                               :isCopyButton="false"
                                               :isDeleteButton="false"
                                               :isAddButton="false"
                                               cellStyle="vertical-align:middle;"
                                               cellClass="sheet-cells"
                                               style="margin-bottom:-15px"
                                               name="sheetCriterions"
                                               :title="[__('Criterion name'), __('Weight'), __('Assessment'), __('Result'), __('Justification')]">
                                <template #repeat="slotProps">
                                    <td :class="slotProps.cellClass"
                                        :style="slotProps.cellStyle">
                                        <FormDropdown :style="{ width: 'auto' }"
                                                      fieldName="weight"
                                                      optionClass="sheet-option-items"
                                                      inputStyle="width:10px"
                                                      class="weight-criterion"
                                                      :itemSize="20"
                                                      :isFormDisabled="true"
                                                      :inRepeater="true"
                                                      :filtering="false"
                                                      :options="select?.criterion_names"
                                                      v-model:field="slotProps.record.criterion_name" />
                                    </td>

                                    <td :class="slotProps.cellClass"
                                        :style="slotProps.cellStyle">
                                        <FormDropdown :style="{ width: 'auto' }"
                                                      fieldName="weight"
                                                      optionClass="sheet-option-items"
                                                      inputStyle="width:10px"
                                                      class="weight-criterion"
                                                      :itemSize="20"
                                                      :isFormDisabled="slotProps.record.is_weights_change == 0"
                                                      :inRepeater="true"
                                                      :filtering="false"
                                                      :options="select?.weights"
                                                      :change="() => countCriterionResults(slotProps.record)"
                                                      v-model:field="slotProps.record.weight" />
                                    </td>
                                    <td :class="slotProps.cellClass"
                                        :style="slotProps.cellStyle">
                                        <FormDropdown :style="{ width: 'auto' }"
                                                      fieldName="assessment"
                                                      optionClass="sheet-option-items"
                                                      inputStyle="width:50px;"
                                                      scrollHeight="120px"
                                                      :itemSize="25"
                                                      :isFormDisabled="false"
                                                      :inRepeater="true"
                                                      :filtering="false"
                                                      :options="select?.assessments_quality"
                                                      :change="() => countCriterionResults(slotProps.record)"
                                                      v-model:field="slotProps.record.assessment" />
                                    </td>
                                    <td :class="slotProps.cellClass"
                                        :style="slotProps.cellStyle"
                                        style="width:10px;text-align:center;">
                                        <span class="static-text-label">
                                            {{ Math.round(slotProps.record.weight * slotProps.record.assessment / 100) }}%
                                        </span>
                                    </td>

                                    <td :class="slotProps.cellClass"
                                        :style="slotProps.cellStyle">
                                        <FormTextarea fieldName="justification"
                                                      inputClass="sheet-fields"
                                                      style="padding-right:30px"
                                                      :rows="2"
                                                      :cols="30"
                                                      :isFormDisabled="false"
                                                      :inRepeater="true"
                                                      v-model:field="slotProps.record.justification" />
                                    </td>
                                </template>
                            </FormRepeaterTable>

                            <div class="sheet-box-divider"
                                 style="background-color:white;margin:0 -7px 50px 0;border:1px solid lightskyblue;">
                                <FormDropdown v-if="row[0] && row[0]['worker_id']"
                                              fieldName="event_id"
                                              label="HR Events"
                                              :filtering="false"
                                              :showClear="true"
                                              :options="select?.hrevents"
                                              v-model:field="workerHrEvents[row[0]['worker_id']]" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <Button v-if="!isObjectEmpty(collectiveData)"
                            @click="saveAsReady"
                            :disabled="collectiveData?.processing"
                            style="margin:0 5px"
                            severity="success">
                        {{ __('Save as ready') }}
                    </Button>
                    <Button v-if="!isObjectEmpty(collectiveData)"
                            @click="saveAssessment"
                            :disabled="collectiveData?.processing"
                            style="margin:0 5px"
                            severity="info">
                        {{ __('Save assessment') }}
                    </Button>

                    <Button @click="cancelData"
                            :disabled="collectiveData?.processing"
                            style="margin:0 5px"
                            severity="secondary">
                        {{ __('Cancel') }}
                    </Button>
                </div>
            </v-form>
            <!-- </div> -->
        </Dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useForm, router } from '@inertiajs/vue3'
import Button from 'primevue/button';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import FormDropdown from '@crud/FormDropdown.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import Dialog from 'primevue/dialog';
import FormInputNumber from '@crud/FormInputNumber.vue'
import { validation, prepareSelect } from '@pages/Helper/crud_utils.js'
import { __, screenMessage, getFromRoute, isObjectEmpty, getTimeouts } from '@pages/Helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    workerSheetsData: Object,
    period: Object
})

const collectiveData = ref(props.workerSheetsData)
const criterionResults = ref(null)
const period = __('year') + ": <span style='color:red;'>" + props.period.year + '</span>, '
    + __('month') + ": <span style='color:red;'>" + props.period.month.substring(1) + '</span>, '
    + __('quarter') + ": <span style='color:red;'>" + props.period.quarter.substring(1) + '</span>'

// -----------------------------------------------------

const isLoading = ref(true);
const workerHrEvents = ref({})
const hrEventsValues = ref({})
let select = ref(null)

// -----------------------------------------------------

onMounted(async () => {
    isLoading.value = true;
    select.value = await prepareSelect(["criterion_names", "weights", "assessments_quality", "hrevent_values"]);

    hrEventsValues.value = select.value.hrevent_values.reduce((acc, item) => {
        const [eventName, percentValue] = item.label.split('=');
        acc[item.value] = { eventName, percentValue };
        return acc;
    }, {});
    select.value.hrevents = select.value.hrevent_values.map(item => ({ label: item.label.split('=')[0], value: item.value }));

    isLoading.value = false;
})

// -----------------------------------------------------

const countCriterionResults = (record) => {
    //console.log(record)
    criterionResults.value = { [record.worker_id]: { [record.premiumcriterion_id]: record.weight * record.assessment } }
}

// -----------------------------------------------------

const cancelData = () => {
    router.get(route('worker-index'));
}

// -----------------------------------------------------

const saveAsReady = () => {
    saveData('saveAsReady');

}
// -----------------------------------------------------

const saveAssessment = () => {
    saveData('saveAssessment');

}
// -----------------------------------------------------

const saveData = async (saveMethod) => {
    isLoading.value = true;
    const timeouts = getTimeouts()
    const resultCheck = await getFromRoute('sheet-collective-check', { collectiveData: collectiveData.value, workerHrEvents: workerHrEvents.value, saveMethod }, 'post')

    if (resultCheck.status === 'error') {
        isLoading.value = false;
        const message = {
            message: resultCheck.message,
            title: "Collective sheet filling error",
            type: "error",
            position: "center",
            timeout: timeouts.error,
        };
        screenMessage(message);
        return
    }

    const resultSave = await getFromRoute('sheet-collective-save', { collectiveData: collectiveData.value, workerHrEvents: workerHrEvents.value, saveMethod }, 'post')
    if (resultSave.status === 'error') {
        isLoading.value = false;
        const message = {
            message: resultSave.message,
            title: "Collective sheet saving error",
            type: "error",
            position: "center",
            timeout: timeouts.error,
        };
        screenMessage(message);
        return
    }

    isLoading.value = false;
    const message = {
        message: resultSave.message,
        title: "Information",
        type: "success",
        position: "center",
        timeout: timeouts.info,
    };
    screenMessage(message);

    router.get(route('worker-index'));
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
